import styled from "styled-components"
import Context from "./Context"
import { useContext } from "react"
import logo from './logo.png'
import { FaPlus } from "react-icons/fa";

export default function Header(){
    const {id,setId,setMenu,menu,mostrandoTodas,setMostrandoTodas,setTempo}=useContext(Context)
    
    return (
        <Tudo>
            <section>
                <img src={logo} />
                <article>
                    <p>VIDEO</p>
                    <p>NOTES</p>
                </article>
                
            </section>
            <SecaoG>
                <Botao selec={!id&&!mostrandoTodas} style={{width:'120px'}} onClick={()=>{setId(false);setMenu(false);setMostrandoTodas(false)}}> <p>Novo vídeo</p> </Botao>
                <Botao selec={mostrandoTodas} style={{width:'120px'}} onClick={()=>{setMostrandoTodas(true);setMenu(false)}}><p>Notas</p></Botao>
            </SecaoG>
            <SecaoP>
                <Botao selec={mostrandoTodas} style={{width:'70px'}} onClick={()=>{setMostrandoTodas(true);setMenu(false)}}><p>Notas</p></Botao>
                <Botao selec={!id&&!menu&&!mostrandoTodas} style={{width:'100px'}} onClick={()=>{setId(false);setMenu(false);setMostrandoTodas(false)}}><p>Novo vídeo</p>   </Botao>
                <Botao selec={menu} style={{width:'70px'}} onClick={()=>{setMenu(true);setMostrandoTodas(false)}}><p>Vídeos</p></Botao>
            </SecaoP>
        </Tudo>
    )
}
const Botao=styled.button`
background:${p=>p.selec?'#4c4c4c':'transparent'};
color:white;
max-height:45px;
`
const Tudo=styled.div`
justify-content:space-between;
align-items:center;
width:100%;height:60px;
background:black;
button{display:flex;
cursor:pointer;align-items:center;
width:100px;justify-content:space-evenly;
height:50px;
border-radius:10px;border:0;margin-right:10px;
font-size:25px;p{font-size:14px;}
}
section{display:flex;height:100%;align-items:center;}
img{
height:65%;margin:0 8px 0 10px;
}
article{
p{margin:0;
font-family: "Audiowide", sans-serif;color:yellow
}
}
button{cursor:pointer;}
@media(max-width:850px){
section{display:none;}}
`

const SecaoG=styled.aside`
display:flex;height:100%;align-items:center;
margin-right:12px;
> * {
    min-width:180px;
  }
@media(max-width:850px){
display:none;}
`
const SecaoP=styled.aside`
display:flex;height:100%;
justify-content:space-between;
align-items:center;
width:100%;
padding: 0 0px 0 10px;
> * {
    min-width:calc(33.3% - 13.3px);
  }
@media(min-width:850px){
display:none;}
`